import { render, staticRenderFns } from "./PermitHistoryStarter.vue?vue&type=template&id=0bdab4e7&scoped=true&"
import script from "./PermitHistoryStarter.vue?vue&type=script&lang=js&"
export * from "./PermitHistoryStarter.vue?vue&type=script&lang=js&"
import style0 from "./PermitHistoryStarter.vue?vue&type=style&index=0&id=0bdab4e7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdab4e7",
  null
  
)

export default component.exports